export default __webpack_public_path__ + "static/media/uv44_en_head_a1.b1ea9bb6.mp3";